// @ts-nocheck
const DB_NAME = "DeviceDB";
const STORE_NAME = "device";
const KEY = "device_identifier";

let cachedDeviceId = null;

// const getBrowserName = async () => {
//   const ua = navigator.userAgent;
//
//   // Brave detection (must check before Chrome)
//   if (navigator.brave && (await navigator.brave.isBrave())) {
//     return "brave";
//   }
//
//   // Edge
//   if (ua.includes("Edg/")) return "edge";
//
//   // Opera
//   if (ua.includes("Opera") || ua.includes("OPR")) return "opera";
//
//   // Vivaldi
//   if (ua.includes("Vivaldi")) return "vivaldi";
//
//   // Arc
//   if (ua.includes("Arc")) return "arc";
//
//   // Chrome (check after other Chromium browsers)
//   if (ua.includes("Chrome")) return "chrome";
//
//   // Safari
//   if (ua.includes("Safari") && !ua.includes("Chrome")) return "safari";
//
//   // Firefox
//   if (ua.includes("Firefox")) return "firefox";
//
//   return "unknown";
// };
const getBrowserName = async () => {
  const ua = navigator.userAgent;

  try {
    // Brave detection
    if (navigator.brave && (await navigator.brave.isBrave())) {
      return "brave";
    }
  } catch (e) {
    // Brave check failed, continue
  }

  if (ua.includes("Edg/")) return "edge";
  if (ua.includes("Opera") || ua.includes("OPR")) return "opera";
  if (ua.includes("Vivaldi")) return "vivaldi";
  if (ua.includes("Arc")) return "arc";
  if (ua.includes("Chrome")) return "chrome";
  if (ua.includes("Safari") && !ua.includes("Chrome")) return "safari";
  if (ua.includes("Firefox")) return "firefox";

  return "unknown";
};

const openDB = () => {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, 1);

    request.onerror = () => reject(request.error);
    request.onsuccess = () => resolve(request.result);

    request.onupgradeneeded = (event) => {
      const db = event.target.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME);
      }
    };
  });
};

const getFromIndexedDB = async () => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readonly");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.get(KEY);

    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
};

const saveToIndexedDB = async (value) => {
  const db = await openDB();
  return new Promise((resolve, reject) => {
    const transaction = db.transaction(STORE_NAME, "readwrite");
    const store = transaction.objectStore(STORE_NAME);
    const request = store.put(value, KEY);

    request.onsuccess = () => resolve();
    request.onerror = () => reject(request.error);
  });
};

// const initializeDeviceId = async () => {
//   if (cachedDeviceId) return cachedDeviceId;
//
//   let deviceId = await getFromIndexedDB();
//   const browserName = await getBrowserName();
//
//   if (!deviceId) {
//     deviceId = `web-${browserName}-<<${Date.now()}-${Math.random().toString(36).substr(2, 9)}>>`;
//     await saveToIndexedDB(deviceId);
//   }
//
//   cachedDeviceId = deviceId;
//   return deviceId;
// };

const initializeDeviceId = async () => {
  if (cachedDeviceId) return cachedDeviceId;

  try {
    let deviceId = await getFromIndexedDB();

    if (!deviceId) {
      const browserName = await getBrowserName();
      deviceId = `web-${browserName}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
      await saveToIndexedDB(deviceId);
    }

    cachedDeviceId = deviceId;
    return deviceId;
  } catch (error) {
    // Fallback: use memory-only ID if IndexedDB fails
    if (!cachedDeviceId) {
      const browserName = await getBrowserName();
      cachedDeviceId = `web-${browserName}-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`;
    }
    return cachedDeviceId;
  }
};

// External function to get device ID
export const getDeviceId = () => {
  if (!cachedDeviceId) {
    return null;
  }
  return cachedDeviceId;
};

export { initializeDeviceId, getBrowserName };